import React, { useState } from "react";
import { HiOutlineChevronDown, HiOutlineChevronUp } from "react-icons/hi";

const FAQSection = () => {
  // Array of FAQs
  const faqs = [
    { question: "Do you need access to water and electricity?", answer: "Yes, we require access to an outdoor water tap and, for some services, a standard power socket. Please ensure these are available before booking." },
    { question: "Do I need an appointment?", answer: "Yes, we recommend booking in advance to secure your preferred time slot." },
    { question: "What products do you use?", answer: "We use high-quality, professional-grade cleaning and detailing products for the best results." },
    { question: "How long does a full valet take?", answer: "The time varies depending on the service. A basic valet takes around 1-2 hours, while a full deep clean can take 3-5 hours. We will provide an estimated time when you book." },
    { question: "Can you valet my car in a car park or at my workplace?", answer: "This depends on whether water and power are available at the location. If you are unsure, please check with the property owner or facilities team before booking." },
    { question: "What payment methods do you accept?", answer: "We accept cash, card payments, and online bank transfers." },
    { question: "Do you work in all weather conditions?", answer: "We operate in most weather conditions, but extreme rain, storms, or very cold temperatures may affect our ability to complete the valet. If the weather is unsuitable, we will reschedule at no extra cost." },
    { question: "Do I need to be present during the valet?", answer: "No, as long as we have access to the vehicle, water, and power. You can leave the keys in a safe place or arrange for someone to hand them over." },
  ];

  // State to track which FAQ is open
  const [openFAQ, setOpenFAQ] = useState(null);

  // Toggle FAQ function
  const toggleFAQ = (index) => {
    setOpenFAQ(openFAQ === index ? null : index);
  };

  return (
    <section id="faq" className="bg-gray-900 text-white py-20">
      <div className="container mx-auto px-6 lg:px-12">
        <h2 className="text-4xl font-bold text-center text-[#1C9BF8] mb-6">
          Frequently Asked Questions
        </h2>
        <p className="text-center text-gray-400 mb-10">
          Find answers to some of the most common questions we receive.
        </p>

        {/* Grid Layout - Two Columns on Desktop, Single Column on Mobile */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {faqs.map((faq, index) => (
            <div key={index} className="relative">
              <button
                className="w-full flex justify-between items-center bg-[#1C9BF8] text-white font-medium text-lg p-4 rounded-lg shadow-lg focus:outline-none transition-all duration-300"
                onClick={() => toggleFAQ(index)}
              >
                {faq.question}
                {openFAQ === index ? <HiOutlineChevronUp /> : <HiOutlineChevronDown />}
              </button>

              {/* Updated Answer Section: Integrated into the same box */}
              <div
                className={`transition-all duration-300 ease-in-out bg-[#1483D3] text-white text-sm rounded-b-lg shadow-lg px-4 ${
                  openFAQ === index ? "py-3 opacity-100 max-h-40" : "opacity-0 max-h-0"
                }`}
              >
                {openFAQ === index && <p className="leading-relaxed">{faq.answer}</p>}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
